(function($) {

    'use strict';

    var init = function() {
        initCarousel();
        $( window ).resize(positionNav);
    };

    var initCarousel = function(e){
        var options = {
            items: 1,
            touchDrag: true,
            navSpeed: 600,
            navText: [,],

            center:true,
            
            nav: false,
            dots: false,
            
            stagePadding: 13,
            margin: 13,
            
            responsive: {
                768 : {
                    items: 2,
                    center:false,
                },
                992 : {
                    items: 1,
                    nav: true,

                    stagePadding: 150,
                    margin: 50,

                    onInitialized: positionNav,
                    onRefreshed: positionNav,
                }
            }
        };

        $(".owl-carousel").owlCarousel(options);
    }

    var positionNav = function(e) {
        var owlNav = $('.owl-nav');

        var itemActive = $('.owl-item.active'),
            owlStage = itemActive.closest('.owl-item.active'),
            nextItemRealisation = itemActive.next().find('.realisation-item__thumbnail');

        var nextHeight = nextItemRealisation.height() * 0.7, // css scale, any modification should be repercuted on _last-realisations.scss
            nextHeightOffset = (nextItemRealisation.height() - nextHeight) / 2,
            relativeY = nextHeight + nextHeightOffset,

            nextWidth = nextItemRealisation.width() * 0.7, // css scale, any modification should be repercuted on _last-realisations.scss
            owlNavBtnWidth = owlNav.width() / 2,
            nextWidthOffset = (nextItemRealisation.width() - nextWidth) / 2,
            relativeX = nextItemRealisation.offset().left - owlStage.offset().left - owlNavBtnWidth;

        if(e.type !== "refreshed") {
            relativeX += nextWidthOffset;
        }

        owlNav.css({top: relativeY, left: relativeX});
    }

    $(document).ready(function() {
        init();
    });

})(jQuery);
